import { Injectable } from '@angular/core';
import { CommonService } from "./common.service";
import { ApiService } from "./api.service";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SignalR, SignalRConnection, ConnectionStatus } from 'ng2-signalr';


@Injectable()
export class DashboardService {

  signalRConnections: Array<SignalRConnection> = [];
  conn: SignalRConnection;
  constructor(
    private _signalR: SignalR,
    private _apiService: ApiService,
    private _commonService: CommonService
  ) { }

  startConnection(): SignalRConnection {
    // let conx: SignalRConnection = this._signalR.createConnection();
    // console.log('init Connection');
    // this.addConnection(conx);
    // return conx;
    if (!this.conn) {
      this.conn = this._signalR.createConnection();
      this.conn.status.subscribe((status: ConnectionStatus) => {
        console.log('signalr status :', status);
      });
  
      this.conn.errors.subscribe((error: any) => {
        console.log('signalr errors :', error);
      });
      
      console.log('init Connection');
      this.addConnection(this.conn);
    }

    return this.conn;
  }

  addConnection(conn: SignalRConnection) {
    //add new connections to an array
    if (this.signalRConnections.indexOf(conn) < 0) {
      this.signalRConnections.push(conn);
    }
  }

  closeConnections() {
    this.signalRConnections.forEach(item => {
      item.stop();
    });
    //clear the connectio array
    this.signalRConnections = [];
  }

  getFacilities(customerId) {
    return this._apiService
      .get('', 'api/dashboard/getFacilities/'+ customerId)
  }

  getCustomers() {
    return this._apiService
      .get('', 'api/dashboard/getcustomers')
  }

  updateDefaultDashboard(userId, facilityId, customerId, defaultFlag) {
    return this._apiService
      .post('', 'api/dashboard/updatedefaultdashboard/' + userId + '/' + facilityId + '/' + customerId + '/' + defaultFlag)
  }

  getWidgets(userId, facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getwidgets/' + userId + '/' + facilityId + '/' + customerId)
  }

  getShipmentTypes(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getshipmenttypes/' + facilityId + '/' + customerId)
  }

  getOrderPriorities(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getorderpriorities/' + facilityId + '/' + customerId)
  }

  getCarriers(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getcarriers/' + facilityId + '/' + customerId)
  }

  getCountrycodes(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getcountrycodes/' + facilityId + '/' + customerId)
  }

  getWidgetTypes(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getwidgettypes/' + facilityId + '/' + customerId)
  }

  getCustomerWidgetTypes(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getcustomerwidgettypes/' + facilityId + '/' + customerId)
  }

  saveCustomerWidgetTypes(widgetlist) {
    return this._apiService
      .post('', 'api/dashboard/savecustomerwidgettypes', widgetlist)
  }

  getWaves(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getLookUpKeyValues/' + facilityId + '/' + customerId + '/WAVECODE')
  }

  addWidget(userId, facilityId, customerId, widget) {
    return this._apiService
      .post('', 'api/dashboard/addwidget/' + userId + '/' + facilityId + '/' + customerId, widget)
  }

  editWidget(userId, facilityId, customerId, widget) {
    return this._apiService
      .post('', 'api/dashboard/editwidget/' + customerId, widget)
  }

  getDefaultUserPreference(userId) {
    return this._apiService
      .get('', 'api/dashboard/getdefaultuserpreference/' + userId)
  }

  getWidgetsSettings(userId, facilityId, customerId, warehouseType) {
    return this._apiService
      .get('', 'api/dashboard/getwidgetsettings/' + userId + '/' + facilityId + '/' + customerId + '/' + warehouseType)
  }

  removeWidget(widgetId, userPreferenceId) {
    return this._apiService
      .post('', 'api/dashboard/removewidget/' + widgetId + '/' + userPreferenceId)
  }

  switchCustomer(userId, facilityId, customerId) {
    return this._apiService
      .post('', 'api/dashboard/switchCustomerSettings/' + userId + '/' + facilityId + '/' + customerId)
  }

  saveWidgetlocation(widgetlist) {
    return this._apiService
      .post('', 'api/dashboard/saveWidgetlocation', { "widgetlist": widgetlist })
  }

  getLookUpReleasedWaves(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getLookUpReleasedWaves/' + facilityId + '/' + customerId)
  }
  getLookUpPutwall(facilityId, customerId) {
    return this._apiService
      .get('', 'api/dashboard/getLookUpPutwall/' + facilityId + '/' + customerId)
  }

}



// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts